import { request, interceptors } from 'axios';

const defaultOptions = {
  responseType: 'json'
};

/**
 * The main API access function that comes preconfigured with useful defaults.
 *
 * @param {string} [method] - the HTTP method to use
 * @param {string} [endpoint] - the API endpoint to use
 * @param {object} [requestOptions] - params and date to be sent
 * @return {Promise} a Promise that will resolve into an object or reject with
 *                   an error object for its reason
 */
export default function(method, endpoint, requestOptions = {}) {
  let requestParams = {
    method: method,
    url: endpoint,
    ...defaultOptions,
    ...requestOptions
  };

  return request(requestParams)
    .then(response => { return response.data; })
    .catch(error => {
      let {response} = error;
      console.error(`[API][${method}][${endpoint}]`, response.status, response.data);

      throw response.data;
    });
}

// Set up request and response interceptors
// Used in tests to query the request queue

window.VCL = {};
window.VCL.requestManager = { pending: 0 };

interceptors.request.use(
  config => {
    window.VCL.requestManager.pending++;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

interceptors.response.use(
  response => {
    window.VCL.requestManager.pending--;
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);
